import { BruksklasseNormalTransport, BruksklasserNormalTransport, useRouteSettings, useRouteSettingsActions } from "../../stores/RouteSettingsStore";
import { SelectInput } from "../common/SelectInput";

export default function BruksklasseNormalTransportSettings() {
    const routeSettings = useRouteSettings();
    const { setRouteSettings } = useRouteSettingsActions();

    return(
        <>
            {routeSettings.routeType === "bruksklasseNormalTransport" && 
                <SelectInput<BruksklasseNormalTransport> 
                    allowedValues={BruksklasserNormalTransport}
                    label="Bruksklase normaltransport" 
                    value={routeSettings.bruksklasseNormalTransport}
                    onChange={(value:BruksklasseNormalTransport) => {setRouteSettings({...routeSettings, bruksklasseNormalTransport: value})}}
                />
            }
        </>
    )
}